import { createElement, useContext } from 'react';
import { RouteComponentProps } from 'react-router';

import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';
import _ProjectDiffPage from '../page/ProjectDiffPage';

type RouteParams = {
  projectId: string;
};
type Props = RouteComponentProps<RouteParams>;

const ProjectDiffPage = ({ match }: Props) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const history = useContext(HistoryContext);

  return (
    <_ProjectDiffPage
      project={state.project.project}
      projectChange={state.projectChange.projectChange}
      assetFiles={state.project.assetFiles}
      briefFiles={state.project.briefFiles}
      latestBriefFiles={state.projectChange.latestBriefFiles}
      beforeBriefFiles={state.projectChange.beforeBriefFiles}
      projectLoading={state.project.projectFetching >= 1 || state.projectChange.fetching >= 1}
      onClickPrevButton={() => history.push(`/projects/${match.params.projectId}/brief`)}
      onMount={async () => {
        dependency.authenticationUsecase.needSignedIn();
        await dependency.showProjectUsecase.prepareProject(match.params.projectId);
        if (state.project.project) {
          dependency.showProjectUsecase.prepareProjectChanges(state.project.project);
        }
      }}
      onUnmount={() => dependency.showProjectUsecase.disposeProject()}
    />
  );
};

export default ProjectDiffPage;
